const BASKET_RETRIEVAL_TOKEN = 'retrievalToken';
const DEPOSIT_AMOUNT = 'depositAmount';
const CTA_CLICKED = 'cta_clicked';
const AUTH_RETURN_URL = 'returnUrl';
const POSITION_ID = 'positionId';
const BASKET_ID_PARAM = 'basketId';
const IS_EXISTING_CUSTOMER = 'isExistingCustomer';

export {
  BASKET_RETRIEVAL_TOKEN,
  DEPOSIT_AMOUNT,
  CTA_CLICKED,
  AUTH_RETURN_URL,
  POSITION_ID,
  BASKET_ID_PARAM,
  IS_EXISTING_CUSTOMER,
};
